import { TFunction } from 'i18next';
import { FeatureAvailability, TicketFeature } from 'apollo/types';

export const getFeatureNote = (
  feature: TicketFeature,
  t: TFunction
): string | null | undefined =>
  feature.availability === FeatureAvailability.AccordingToAvailability
    ? t('pages.ticketInformation.accordingToAvailability')
    : feature.note;

const getFeatureLabel = (feature: TicketFeature, t: TFunction): string => {
  const note = getFeatureNote(feature, t);
  return note ? `${feature.name} (${note})` : feature.name;
};

export default getFeatureLabel;
